module.exports = __webpack_public_path__ + "media/cash-register.978e39ac.mp3";